import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/videoOutput.gif'
import _imports_1 from '../../assets/images/assetediting.gif'


const _withScopeId = n => (_pushScopeId("data-v-43a8d095"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "texture",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_2 = { class: "core-tap-text-back back-light" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "container" }
const _hoisted_5 = { class: "container" }
const _hoisted_6 = { class: "core-tap-text-back textureBack" }
const _hoisted_7 = { class: "title" }
const _hoisted_8 = { class: "container" }
const _hoisted_9 = { class: "container" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "texture",
  src: _imports_1,
  height: "430",
  alt: ""
}, null, -1))

import { Swiper, SwiperSlide } from "swiper/vue/swiper-vue";
import "swiper/swiper-bundle.css";
import { Pagination, Autoplay } from "swiper";


export default /*#__PURE__*/_defineComponent({
  __name: 'EnCoreFunctionsTab2',
  setup(__props) {

const modules = [Pagination, Autoplay];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Swiper), {
    class: "indexEnSwiperBox",
    modules: modules,
    pagination: { clickable: true },
    autoplay: { deley: 3000, disableOnInteraction: false }
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(SwiperSlide), null, {
        default: _withCtx(() => [
          _hoisted_1,
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("p", null, _toDisplayString(_ctx.$t("home.tap2_button_text1")), 1)
            ]),
            _createElementVNode("h3", null, _toDisplayString(_ctx.$t("home.core_funs_contents3_top")), 1),
            _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t("home.core_funs_contents3_center")), 1),
            _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t("home.core_funs_contents3_bom")), 1)
          ])
        ]),
        _: 1
      }),
      _createVNode(_unref(SwiperSlide), null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("p", null, _toDisplayString(_ctx.$t("home.tap2_button_text2")), 1)
            ]),
            _createElementVNode("h3", null, _toDisplayString(_ctx.$t("home.core_funs_contents4_top")), 1),
            _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t("home.core_funs_contents4_center")), 1),
            _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$t("home.core_funs_contents4_bom")), 1)
          ]),
          _hoisted_10
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})